import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconThumbsDown24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.93 12.536h1a1.5 1.5 0 0 0 1.5-1.5v-4a1.5 1.5 0 0 0-1.5-1.5h-1zm-1.5-7H8.205a1.5 1.5 0 0 0-1.314.777l-2.2 4a1.5 1.5 0 0 0 1.314 2.223h5.125l-.21 1.686-.532 4.273 4.93-5.464.114-.126zM8.899 18.31l.346-2.774.187-1.5H6.004c-2.281 0-3.728-2.446-2.628-4.445l2.2-4a3 3 0 0 1 2.628-1.555h9.727a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-1.5L11.5 19.5c-.983 1.09-2.784.265-2.603-1.19"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown24);
